import { apiClient } from "@/modules/shared/utils/apiClient";

import { CreateSessionRequest } from "../types/CreateSessionRequest";

export const createSessionRequest = (data: CreateSessionRequest) =>
  apiClient.post("/coaching-session/create", data);
